export const LOAD_USECASE_BY_PLANTS = 'LOAD_USECASE_BY_PLANTS';
export const LOAD_USECASE_BY_PLANTS_SUCCESS = 'LOAD_USECASE_BY_PLANTS_SUCCESS';
export const LOAD_USECASE_BY_PLANTS_ERROR = 'LOAD_USECASE_BY_PLANTS_ERROR';